"use client";

import Link from "next/link";
import { useParams, useSearchParams } from "next/navigation";

export function AdminArticleListButton() {
  const params = useParams<{ slug: string }>();
  const slug = params?.slug || "";
  const searchParams = useSearchParams();

  return (
    <Link
      href={{
        pathname: `/admin/${slug}`,
        query: searchParams?.toString(),
      }}
      className="btn btn-white"
      role="button"
    >
      <i className="fa fa-list"></i>
      <span> 목록</span>
    </Link>
  );
}
